import { DownArrow, EyesIcon, LikeIcon, LinkArrowIcon, VideoImage } from 'assets'

import { DropDown, PostCard, VideoCard } from 'components'
import { useOutsideClick } from 'Hooks'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { getTopPostsListAction, resetTotalPostsCount } from 'store/action/instagramDashboard'
import { onResetVideoCount } from 'store/action/videoReducer'
import InPostsCard from '../InPostsCard'

function TopPostsSection() {
   const [videoFilter, setVideoFilter] = useState('Recent Posted')
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const instagramDashboard = useSelector((state) => state.instagramDashboard)
   const { getTopPostsList, inDashboardData } = instagramDashboard

   const location = useLocation()

   const onSeletedValue = (data) => {
      setVideoFilter(data)
   }

   useEffect(() => {
      console.log('inDashboardData', inDashboardData)
      if (inDashboardData) {
         dispatch(getTopPostsListAction())
         // dispatch(resetTotalPostsCount())
      }
      return () => {}
   }, [inDashboardData])

   return (
      <div className="video-section">
         {getTopPostsList && getTopPostsList.length > 0 ? (
            <>
               <div className="video-title-section">
                  <div className="">
                     <p className="at-text-dark at-font-20">Total Posts</p>
                     {/* <span className="at-text-light  at-font-14">242 Items</span> */}
                  </div>
                  <div className="d-flex align-items-center justify-content-start gap-3">
                     
                     <div
                        className="channel-btn"
                        onClick={() => {
                           navigate(`/instagram/posts-reel`)
                        }}>
                        <span>All Posts</span>
                        <LinkArrowIcon />
                     </div>
                  </div>
               </div>
               <div className="video-wrap mt-3">
                  <div className="row">
                     {getTopPostsList &&
                        getTopPostsList?.length > 0 &&
                        getTopPostsList?.map((item, i) => {
                           return (
                              <div className="col-12 col-lg-4 mt-2" key={i}>
                                 <PostCard items={item} />
                              </div>
                           )
                        })}
                  </div>
               </div>
            </>
         ) : null}
      </div>
   )
}

export default TopPostsSection
